import type { FC, ReactNode } from "react";
import { AuthConfigContext } from "../../contexts/AuthConfigContext";
import type { AuthConfig } from "../../types";

export type AuthConfigProviderProps = {
  /**
   * Auth configuration object with Auth0, API, and cookie settings
   */
  config: AuthConfig;
  /**
   * Child components that will have access to the auth config
   */
  children: ReactNode;
};

/**
 * Provides auth configuration to all auth components.
 * Must wrap any component that uses useAuthConfig() or auth components like AuthScreens.
 */
export const AuthConfigProvider: FC<AuthConfigProviderProps> = ({
  config,
  children,
}) => (
  <AuthConfigContext.Provider value={config}>
    {children}
  </AuthConfigContext.Provider>
);
